export default __webpack_public_path__ + "static/media/logoAD.04c0c5fb.png";